import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import Pricing from "../../landing-page/components/Pricing";
import PricingTable from "../../landing-page/components/PricingTable";
import FAQ from "../../landing-page/components/FAQ";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { buildWebPageLd } from "../../shared/seoJsonLd";
import { getFaqs } from "../../landing-page/contentSections";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/tarifs";

export default function PricingPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const faqs = getFaqs(t);
  return (
    <MarketingPageLayout>
      <SeoHelmet
        path={PATH}
        title={m.title}
        description={m.description}
        jsonLd={[buildWebPageLd({ name: m.title, description: m.description, path: PATH })]}
      />
      <div className="pt-24">
        <Pricing />
        <PricingTable />
        <FAQ faqs={faqs} />
      </div>
      <CtaFinal />
    </MarketingPageLayout>
  );
}
